export class GetDepositRequestParams {
  pageNo: number = 1;
  rowPerPage: number = 10;
  filter: string = '';
  categoryCode: string | null = null;
  merchantCode: string | null = null;
  providerCode: string | null = null;
  type: string = '2'; // value 2 is deposit type
  status: string | null = null;
  createdFrom: string | null = null;
  createdTo: string | null = null;
}

export class CreateDepositParams {
  amount: number = 0;
  file!: File; // ← tambahkan "!"
  status: string | null = null;
}

export class UpdateDepositRequestParams extends CreateDepositParams {
  oldPassword?: string;
}

export interface DepositData {
  id: string;
  tx_id: string;
  bill_id: string | null;
  ref_id: string;
  amount: number;
  fee_merchant: number;
  fee_bank: number;
  fee: number;
  fee_benefit: number;
  total_amount: number;
  total_admin: number;
  deducted_balance: number;
  type: string;
  status: string;
  sign: string;
  merchant_code: string;
  provider_code: string;
  category_code: string;
  product_code: string;
  tx_detail: string;
  first_balance: number;
  last_balance: number;
  req_inq_param: string;
  res_inq_param: string;
  req_pay_param: string;
  res_pay_param: string;
  batch_time: number;
  active: string;
  va_no: string | null;
  va_bank_code: string | null;
  bank_ref_id: string | null;
  is_settlement: number;
  status_name: string;
  product_name: string;
  merchant_name: string;
  provider_name: string;
  category_name: string;
  created_by: string;
  updated_by: string;
  created_at: string;
  updated_at: string;
  media: Media;
}

export interface Media {
  ID: string;
  table_name: string;
  ref_id: string;
  media_name: string;
  file_type: string;
  media: string;
  CreatedAt: string;
  CreatedBy: string;
  UpdatedAt: string;
  UpdatedBy: string;
}

export interface GetDepositResponse {
  code: number;
  message: string;
  data: DepositData[];
  currPage: number;
  haveNext: boolean;
  totalPage: number;
}

export interface GetDepositByIdResponse {
  code: number;
  message: string;
  data: DepositData;
}

export interface DeleteDepositByIdResponse {
  code: number;
  message: string;
  data: boolean;
}
